import { createSlice } from '@reduxjs/toolkit';

export const visualizationModeSlice = createSlice({
	name: 'visualizationMode',
	initialState: {
		value: false,
	},
	reducers: {
		setVisualizationMode: (state, action) => {
			state.value = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setVisualizationMode } = visualizationModeSlice.actions;
export const visualizationMode = (state) => state.visualizationMode.value;
export default visualizationModeSlice.reducer;
